import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Injectable, inject } from '@angular/core';
import { WindowRef } from './window/window-ref';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private winRef = inject(WindowRef);
  private gtmService = inject(GoogleTagManagerService);

  pushTag(tag: object) {
    if (this.winRef.isBrowser()) {
      this.gtmService.pushTag(tag);
    }
  }
}
